import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, has } from 'lodash';

import { isCloudinaryHostedImage, attachCloudinaryOptionsToImageSource } from '../utils/ImageUtils';

class Image extends Component {
    static propTypes = {
        style: PropTypes.object,
        src: PropTypes.string,
        className: PropTypes.string,
        dimension: PropTypes.shape({
            w: PropTypes.number,
            h: PropTypes.number
        }),
        quality: PropTypes.object,
        cloudinaryCrop: PropTypes.string,
        colorize: PropTypes.number,
        alt: PropTypes.string,
        title: PropTypes.string,
        overlay: PropTypes.object,
        radius: PropTypes.string,
        textProp: PropTypes.object,
        color: PropTypes.string,
        effect: PropTypes.string
    };

    render() {
        const {
            style,
            src,
            className,
            alt,
            dimension = {},
            quality = {},
            cloudinaryCrop = '',
            title = '',
            color = '',
            colorize = '',
            overlay = {},
            textProp,
            radius,
            effect
        } = this.props;

        // if src's host is cloudinary, ask for the correctly sized image
        const parser = document.createElement('a');
        parser.href = src;

        let optimizedSource = src;
        if (isCloudinaryHostedImage(parser.hostname)) {
            const imageOptions = {};
            if (has(dimension, 'w')) {
                imageOptions.w = dimension.w;
            }
            if (has(dimension, 'h')) {
                imageOptions.h = dimension.h;
            }
            if (!isEmpty(textProp)) {
                imageOptions.text = {
                    l_text: `${textProp.fontFamily}_${textProp.fontWeight}`,
                    textAlignment: textProp.alignment,
                    textMessage: textProp.message,
                    textY: textProp.textY,
                    textColor: textProp.textColor,
                    backgroundWidth: textProp.backgroundWidth,
                    backgroundHeight: textProp.backgroundHeight,
                    gravity: textProp.gravity
                };
            }
            if (!isEmpty(cloudinaryCrop)) {
                imageOptions.crop = cloudinaryCrop;
            }
            if (radius) {
                imageOptions.radius = radius;
            }
            if (!isEmpty(quality)) {
                imageOptions.q = quality.q;
            }

            if (!isEmpty(color)) {
                imageOptions.color = color;
                if (!isEmpty(colorize)) {
                    imageOptions.colorize = colorize;
                }
            }

            if (!isEmpty(overlay)) {
                imageOptions.overlay = overlay.overlayId;
                imageOptions.overlayDimensions = overlay.dimension;
                imageOptions.overlayGravity = overlay.gravity;
                imageOptions.overlayOpacity = overlay.opacity;
            }

            if (overlay.firstOverlay) {
                imageOptions.firstOverlay = overlay.firstOverlay;
            }

            if (overlay.secondOverlay) {
                imageOptions.secondOverlay = overlay.secondOverlay;
            }

            if (!isEmpty(effect)) {
                imageOptions.effect = effect;
            }

            // replaces all http with https images
            optimizedSource = attachCloudinaryOptionsToImageSource(optimizedSource, imageOptions);
        }

        return <img style={style} src={optimizedSource} className={className} title={title} alt={alt} />;
    }
}

export default Image;
